import CommentCard from "./CommentCard"

const CommentsSection = ({ doctor }) => {
    const doctorName = doctor.name

    // فعلاً کامنت‌های نمونه
    const comments = []

    return (
        <div
        className="bg-white p-5 rounded-[15px]"
        >
            <h4 className="font-semibold text-[18px] mt-5">
                <span className="me-1">‌نظرات کاربران درباره‌ی دکتر</span>
                <span>{doctorName}</span>
            </h4>

            {comments.length > 0 ? (
                comments.map((cm) => (
                    <CommentCard
                        key={cm.id}
                        name={cm.name}
                        text={cm.text}
                        score={cm.score}
                        date={cm.date}
                    />
                ))
            ) : (
                <p className="text-gray-500 mt-3">هیچ نظری ثبت نشده است.</p>
            )}
        </div>
    )
}

export default CommentsSection
